import { render, staticRenderFns } from "./SubPage.vue?vue&type=template&id=5f70c32a&"
import script from "./SubPage.vue?vue&type=script&lang=js&"
export * from "./SubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports